import { Modal } from 'react-bootstrap';
import LoginFormBodyEmail from './LoginFormBodyEmail';
import LoginOtpBodyEmail from './LoginOtpBodyEmail';

function UserLoginModal({
  signIn,
  signInWithGoogle,
  signInWithFacebook,
  signInWithTwitter,
  show,
  setShow,
  onCloseClick,
  showOtp,
  openRegistrationModal,
  openForgetPasswordModal,
}) {
  return (
    <Modal
      size='md'
      show={show}
      onHide={() => {
        setShow(false);

        if (typeof onCloseClick === 'function') {
          onCloseClick();
        }
      }}
      centered
      aria-labelledby='example-modal-sizes-title-lg'
      contentClassName='custom-login-content btn-close-custom'
      backdropClassName='modal-backdrop-login'
    >
      <Modal.Header closeButton>
        <Modal.Title>User Login</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!showOtp ? (
          <LoginFormBodyEmail
            signIn={signIn}
            signInWithGoogle={signInWithGoogle}
            signInWithFacebook={signInWithFacebook}
            signInWithTwitter={signInWithTwitter}
            setShow={setShow}
            openRegistrationModal={openRegistrationModal}
            openForgetPasswordModal={openForgetPasswordModal}
          />
        ) : (
          <LoginOtpBodyEmail
            signInWithGoogle={signInWithGoogle}
            signInWithFacebook={signInWithFacebook}
            signInWithTwitter={signInWithTwitter}
            setShow={setShow}
            openRegistrationModal={openRegistrationModal}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default UserLoginModal;
